<template>
    <div>
        <div class="dialog-content">
            <div class="dialog-c-title">Benutzer hinzufügen</div>
            <label class="above">
                Login:
                <input type="text" v-model="newUser.login">
            </label>
            <label class="above">
                Name:
                <input type="text" v-model="newUser.username">
            </label>
            <label class="above">
                Rolle:
                <input type="text" v-model="newUser.role">
            </label>
            <label class="above">
                Password:
                <input type="password" v-model="newUser.password" :class="{error: passwordStrength !== true}">
                <div class="error-message">{{passwordStrength}}</div>
            </label>

            <label>
                Password wiederholen
                <input type="password" v-model="newUser.comparePassword" :class="{error: !compareValid}">
            </label>

        </div>
        <div class="vue-dialog-buttons">
            <button class="vue-dialog-button" @click="$emit('close')">abbrechen</button>
            <button class="vue-dialog-button add" @click="addConfig"
                    :disabled="!newUser.password || !passwordStrength || !compareValid || !newUser.login || !newUser.username || !newUser.role">Benutzer
                hinzufügen
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: [],
        data() {
            return {
                newUser: this.initNewUser()
            }
        },
        methods: {
            initNewUser: function () {
                return {
                    login: '',
                    username: '',
                    password: '',
                    comparePassword: '',
                    role: 'user',
                    active: true
                };
            },
            addConfig: function () {
                let me = this;

                if (me.compareValid && me.passwordStrength && me.newUser.login && me.newUser.username && me.newUser.role) {
                    me.saving = true;

                    me.$http.post('/data/users', me.qs({'data': JSON.stringify(me.newUser)})).then(function (r) {
                        me.saving = false;

                        me.$notify({
                            text: r.data.msg,
                            type: r.data.msgType
                        });

                        if (r.data.msgType === 'success') {
                            me.$emit('refresh-users');
                            me.newUser = me.initNewUser();
                            me.$emit('close');
                        }
                    });


                } else {
                    me.$notify({
                        text: 'Password form is not valid please check the errors',
                        type: 'error'
                    });
                }
            }
        },
        computed: {
            compareValid: function () {
                let me = this;

                if (me.newUser.password && !me.newUser.comparePassword) {
                    return false;
                }
                if (me.newUser.password && me.newUser.comparePassword && me.newUser.password !== me.newUser.comparePassword) {
                    return false;
                }

                return true;
            },
            passwordStrength: function () {
                let me = this;

                if (!me.newUser.password) {
                    return true;
                }

                if (me.newUser.password.length < 8) {
                    return 'Das Password sollte mindestens 8 Zeichen lang sein';
                }

                if (!/\d/.test(me.newUser.password)) {
                    return 'Das Password sollte mindestens eine Zahl enthalten'
                }

                if (!/[~`!#$%^&*+=\-[\]\\';,/{}|":<>?]/g.test(me.newUser.password)) {
                    return 'Das Password sollte mindestens eine Sonderzeichen enthalten'
                }

                return true;
            }
        }
    }
</script>